// Local gallery images (no Google Drive)
//
// Images live in: src/images/our-moments/
// Add/remove imports here to control what shows up in the gallery.

import IMG_2121 from "../images/our-moments/IMG_2121.jpeg";
import IMG_2296 from "../images/our-moments/IMG_2296.jpeg";
import IMG_4391 from "../images/our-moments/IMG_4391.jpeg";
import IMG_5925 from "../images/our-moments/IMG_5925.jpeg";
import IMG_8657 from "../images/our-moments/IMG_8657.jpeg";
import IMG_9012 from "../images/our-moments/IMG_9012.jpeg";
import IMG_9102 from "../images/our-moments/IMG_9102.jpeg";
import IMG_9960 from "../images/our-moments/IMG_9960.jpeg";

// Keep exports for backwards compatibility with existing imports
export const GOOGLE_DRIVE_FOLDER_ID = "";
export const GOOGLE_DRIVE_API_KEY = "";

export const galleryImages = [
  IMG_2121,
  IMG_2296,
  IMG_4391,
  IMG_9012,
  IMG_5925,
  IMG_8657,
  IMG_9102,
  IMG_9960,
];
